import _extends from "@babel/runtime/helpers/extends";
import React, { useMemo } from 'react';
import { CardClient, SmartCardProvider } from '@atlaskit/link-provider';
import { RendererWithAnalytics as AkRenderer } from '@atlaskit/renderer';
import { useHubExtensionHandlers } from '../../controllers/use-hub-extension-handlers';
export var HubRenderer = function HubRenderer(props) {
  var product = props.product;
  var extensionHandlers = useHubExtensionHandlers({
    contentId: '123',
    PropsProvider: function PropsProvider(_ref) {
      var children = _ref.children;
      return /*#__PURE__*/React.createElement(React.Fragment, null, children);
    }
  });
  var smartCardClient = useMemo(function () {
    return new CardClient();
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "hub-renderer"
  }, /*#__PURE__*/React.createElement(SmartCardProvider, {
    product: product,
    client: smartCardClient
  }, /*#__PURE__*/React.createElement(AkRenderer, _extends({}, props, {
    extensionHandlers: extensionHandlers
  }))));
};
export default HubRenderer;